export enum ColumnType {
    DecimalColumn = 'DecimalColumn',
    IntegerColumn = 'IntegerColumn',
    BooleanColumn = 'BooleanColumn',
    DateColumn = 'DateColumn',
    TimestampColumn = 'TimestampColumn',
    TimeColumn = 'TimeColumn',
    StringColumn = 'StringColumn',
    DetailColumn = 'DetailColumn',
    EditColumn = 'EditColumn',
    DocumentationColumn = 'DocumentationColumn',
    SortOrderColumn = 'SortOrderColumn',
    HierarchyLevelColumn = 'HierarchyLevelColumn',
    MinuteAndSecondColumn = 'MinuteAndSecondColumn'
}
